import { getState } from './state';
import { createSelector } from 'reselect';

export const getAltchaSlice = createSelector([getState], slice => {
  return slice.altcha;
});

/**
 * Get the altcha verification token for message sending from state
 */
export const getAltchaWithMsgToken = (state: any): string | undefined => {
  const damzState = getAltchaSlice(state);
  return damzState?.withMsgToken;
};

/**
 * Get the altcha verification token for room/channel creation from state
 */
export const getAltchaWithoutMsgToken = (state: any): string | undefined => {
  const damzState = getAltchaSlice(state);
  return damzState?.withoutMsgToken;
};
